const PRODUCTION_DOMAIN = 'snoball.it';
const APP_HOST_PREFIXES = ['i', 'api', 'www', 'app'];
const ENV_NAME_ALIASES: { [key: string]: string } = { tech: 'sandbox' };
const UNKNOWN_BUILD_ENV_NAMES = ['', 'default', 'production'];
const GENERIC_LABEL = 'testing environment';

function hostLabels(hostname: string): string[] {
  const host = (hostname || '')
    .toLowerCase()
    .trim()
    .replace(/:\d+$/, '')
    .replace(/\.$/, '');

  if (!host) {
    return [];
  }

  const labels = host.split('.');
  return APP_HOST_PREFIXES.indexOf(labels[0]) !== -1 && labels.length > 1
    ? labels.slice(1)
    : labels;
}

function envNameFromHost(labels: string[]): string {
  const host = labels.join('.');

  if (host.endsWith('.' + PRODUCTION_DOMAIN)) {
    const prefix = host.slice(0, host.length - PRODUCTION_DOMAIN.length - 1);
    return prefix.split('.').pop() || '';
  }

  if (labels.length >= 2 && labels[labels.length - 2] === 'snoball') {
    return labels[labels.length - 1];
  }

  return '';
}

function envNameFromBuild(buildEnvName?: string): string {
  const name = (buildEnvName || '').toLowerCase().trim();
  return UNKNOWN_BUILD_ENV_NAMES.indexOf(name) === -1 ? name : '';
}

export function resolveEnvironmentLabel(hostname: string, buildEnvName?: string): string | null {
  const labels = hostLabels(hostname);

  if (!labels.length || labels.join('.') === PRODUCTION_DOMAIN) {
    return null;
  }

  const name = envNameFromHost(labels) || envNameFromBuild(buildEnvName);

  return name ? (ENV_NAME_ALIASES[name] || name) + ' environment' : GENERIC_LABEL;
}
